import { useCallback, useEffect, useMemo, useRef } from 'react';
import { getUseCase, RequestStatus } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { GET_AI_CHAT_USAGE_WALLET_USE_CASE } from '../../../redux/ai-chat/ai-chat.action';
import { selectUsageWallet, selectUsageWalletStatus } from '../../../redux/ai-chat/ai-chat.selectors';

var getProgressColor = function getProgressColor(percent) {
  if (percent >= 60) return '#52C41A';
  if (percent >= 30) return '#FAAD14';
  if (percent >= 10) return '#FF8C00';
  return '#FF4D4F';
};

export var useCreditBalance = function useCreditBalance() {
  var dispatch = useDispatch();
  var usageWallet = useSelector(selectUsageWallet);
  var usageWalletStatus = useSelector(selectUsageWalletStatus);
  var getUsageWalletUseCase = getUseCase(GET_AI_CHAT_USAGE_WALLET_USE_CASE, dispatch);
  var hasFetched = useRef(false);
  var fetchBalance = useCallback(function () {
    getUsageWalletUseCase.execute(null);
  }, [getUsageWalletUseCase]);
  useEffect(function () {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchBalance();
  }, [fetchBalance]);
  useEffect(function () {
    var lastFetch = Date.now();

    var handleVisibility = function handleVisibility() {
      if (document.visibilityState === 'visible' && Date.now() - lastFetch > 60000) {
        lastFetch = Date.now();
        fetchBalance();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return function () {
      return document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [fetchBalance]);
  var percent = useMemo(function () {
    if (!usageWallet) return -1;
    var total = usageWallet.totalTokens || 0;
    var available = usageWallet.totalAvailableTokens || 0;
    return total > 0 ? Math.round(available / total * 100) : 0;
  }, [usageWallet]);
  var loading = usageWalletStatus === RequestStatus.EXECUTE || usageWalletStatus === null;
  return {
    percent: percent,
    loading: loading,
    color: getProgressColor(percent),
    refreshAt: (usageWallet === null || usageWallet === void 0 ? void 0 : usageWallet.nextRefreshTime) || null,
    refetch: fetchBalance
  };
};